import React, { ReactNode } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import PropTypes from "prop-types";

import SplashLoader from "components/atoms/SplashLoader/SplashLoader";

interface PrivateRouteProps {
  children: ReactNode;
}

function PrivateRoute({ children }: PrivateRouteProps) {
  return <>{children}</>;
}

export default withAuthenticationRequired(PrivateRoute, { onRedirecting: () => <SplashLoader /> });

PrivateRoute.prototype = {
  children: PropTypes.node,
};
